// Shared UI tokens + framer-motion variants for the media kit

export const CLAY_CARD =
  "rounded-[2.25rem] border-[3px] border-clay-ink shadow-clay";
export const BRUTAL_BORDER = "border-[3px] border-clay-ink";
export const BRUTAL_SHADOW = "shadow-brutal";

export const fadeUp = {
  hidden: { opacity: 0, y: 42 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export const viewportOnce = { once: true, amount: 0.25 };

export const lineReveal = {
  hidden: { y: "115%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1], delay: 0.15 + i * 0.11 },
  }),
};
